import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { LoadingStatus } from 'GeminiViewerComponent/helpers/AsyncStatus';
import { activateLoading, deactivateLoading } from 'GeminiViewerComponent/features/globals/loadingProgressSlice';
import { CompanionAppsTable } from './CompanionAppsTable';
import {
    fetchAllCompanionApps,
    getAllCompanionApps,
    getCompanionLoadingStatus,
    getCompanionPageInfo,
    resetCompanionAppStatus,
} from 'GeminiViewerComponent/features/companionApps/companionAppsSlice';

const CompanionAppsTab = () => {
    const dispatch = useDispatch();
    const ref = useRef(false);
    const companionApps = useSelector(getAllCompanionApps);
    const companionStatus = useSelector(getCompanionLoadingStatus);
    const pageInfo = useSelector(getCompanionPageInfo);
    const [sortBy, setSortBy] = useState('display_name');
    const [sortDirection, setSortDirection] = useState('ASC');
    const [companionPayload, setCompanionPayload] = useState({
        sort: `${sortDirection === 'ASC' ? '' : '-'}${sortBy}`,
    });

    const getCompanionData = async (payload) => {
        dispatch(activateLoading());
        await dispatch(fetchAllCompanionApps({ ...payload }));
        dispatch(deactivateLoading());
    };

    useEffect(() => {
        if (ref.current === true) {
            getCompanionData({ ...companionPayload });
        }
        return () => {
            dispatch(resetCompanionAppStatus());
        };
    }, [companionPayload]);

    useEffect(() => {
        if (companionStatus === LoadingStatus.Idle) {
            getCompanionData({ ...companionPayload });
        }
        ref.current = true;
    }, [companionStatus]);

    const setSorting = (_sortBy, _sortDirection) => {
        setSortBy(_sortBy);
        setSortDirection(_sortDirection);
        setCompanionPayload({
            ...companionPayload,
            sort: `${_sortDirection === 'ASC' ? '' : '-'}${_sortBy}`,
        });
    };

    return (
        <CompanionAppsTable
            companionApps={companionApps}
            pageInfo={pageInfo}
            companionPayload={companionPayload}
            setCompanionPayload={setCompanionPayload}
            sortDirection={sortDirection}
            sortBy={sortBy}
            handleSort={(_sortBy, _sortDirection) => setSorting(_sortBy, _sortDirection)}
        />
    );
};

export { CompanionAppsTab };
